import {
  PublicReviewsOfLeaderQuery,
  PublicReviewsOfLeaderQueryVariables,
} from "@outschool/gql-frontend-generated";
import { ApolloError, QueryResult, gql } from "@outschool/ui-apollo";
import React from "react";

import {
  LeaderFragment,
  LightActivityFragment,
  PublicReviewFragment,
  usePaginatedQuery,
} from "../index";

export const publicReviewsOfLeaderQuery = gql`
  query PublicReviewsOfLeader(
    $leaderUid: ID
    $offset: Int!
    $limit: Int!
    $skipAggregates: Boolean!
    $includeSummary: Boolean!
  ) {
    publicProfile: publicProfileNew(uid: $leaderUid) {
      uid
      leader {
        ...LeaderFragment
        uid
        recentReviews(offset: $offset, limit: $limit) {
          ...PublicReviewFragment
          activity {
            ...LightActivityFragment
          }
        }
        averageActivityStarRating @skip(if: $skipAggregates)
        reviewCount @skip(if: $skipAggregates)
        reviewsWithTextCount @skip(if: $skipAggregates)
        feedbackSummary @include(if: $includeSummary) {
          uid
          pros
        }
      }
    }
  }
  ${LeaderFragment}
  ${PublicReviewFragment}
  ${LightActivityFragment}
`;

export type PublicReviewsOfLeaderQueryOptions = { skip: boolean } & {
  variables: PublicReviewsOfLeaderQueryVariables;
};

export type UsePublicReviewsOfLeaderQueryValue = {
  data: PublicReviewsOfLeaderQuery;
  loading: boolean;
  error: ApolloError | undefined;
  fetchMoreReviews(): Promise<void>;
  isFetchingMore: boolean;
};

export const usePublicReviewsOfLeaderQuery = (
  options: PublicReviewsOfLeaderQueryOptions
): UsePublicReviewsOfLeaderQueryValue => {
  const getItems = React.useCallback(
    (
      result: PublicReviewsOfLeaderQuery
      // @ts-ignore TS(2339): Property 'leader' does not exist on type '{ __type... Remove this comment to see the full error message
    ): PublicReviewsOfLeaderQuery["publicProfile"]["leader"]["recentReviews"] =>
      // @ts-ignore TS(2531): Object is possibly 'null'.
      result.publicProfile.leader.recentReviews,
    []
  );

  const getResult = React.useCallback(
    (
      previousResult: PublicReviewsOfLeaderQuery,
      fetchMoreResult: PublicReviewsOfLeaderQuery,
      // @ts-ignore TS(2339): Property 'leader' does not exist on type '{ __type... Remove this comment to see the full error message
      items: PublicReviewsOfLeaderQuery["publicProfile"]["leader"]["recentReviews"]
    ): PublicReviewsOfLeaderQuery => ({
      publicProfile: {
        __typename: "PublicProfile",
        ...previousResult.publicProfile,
        ...fetchMoreResult.publicProfile,
        // @ts-ignore TS(2322): Type '{ recentReviews: any; __typename?: "Leader" ... Remove this comment to see the full error message
        leader: {
          // @ts-ignore TS(2531): Object is possibly 'null'.
          ...previousResult.publicProfile.leader,
          // @ts-ignore TS(2531): Object is possibly 'null'.
          ...fetchMoreResult.publicProfile.leader,
          recentReviews: items,
        },
      },
    }),
    []
  );

  const getFetchMoreVariables = React.useCallback(
    (
      result: QueryResult<
        PublicReviewsOfLeaderQuery,
        PublicReviewsOfLeaderQueryVariables
      >
    ): Partial<PublicReviewsOfLeaderQueryVariables> => ({
      // @ts-ignore TS(2345): Argument of type 'PublicReviewsOfLeaderQuery | und... Remove this comment to see the full error message
      offset: getItems(result.data).length,
      skipAggregates: true,
    }),
    [getItems]
  );

  const hasMoreItems = React.useCallback(
    (data: PublicReviewsOfLeaderQuery): boolean => getItems(data).length > 0,
    [getItems]
  );

  const {
    data,
    loading,
    error,
    fetchMore: fetchMoreReviews,
    isFetchingMore,
  } = usePaginatedQuery(
    publicReviewsOfLeaderQuery,
    options,
    getItems,
    getResult,
    getFetchMoreVariables,
    hasMoreItems
  );

  return {
    // @ts-ignore TS(2322): Type 'PublicReviewsOfLeaderQuery | undefined' is n... Remove this comment to see the full error message
    data,
    loading,
    error,
    fetchMoreReviews,
    isFetchingMore,
  };
};
